<div tabindex="0" class="modal fade wb-dialog-modal" role="dialog" #confirmModalDialogContainer
    (click)="onContainerClicked($event)" 
    (keyup)="onKeyPressed($event)"   
    [ngClass]="{'in': this.visibleAnimate, 'out': !this.visibleAnimate}"
    [ngStyle]="{'display': this.visible ? 'block' : 'none', 'opacity': this.visibleAnimate ? 1 : 0}" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
  <div class="modal-dialog wb-dialog-modal-dialog">
    <div class="popup">
      <div class="modal-body">
          <h2 *ngIf="header" class="text-center">{{header}}</h2>
          <h4 *ngIf="subHeader" class="text-center">{{subHeader}}</h4>
          <span *ngIf="message" class="hint-text text-center" [innerHTML]="message"></span>
          <button type="submit" *ngIf="btn1Text" (click)="onBtn1Click()" class="btn wb-btn-default center-block mg-top-24">{{btn1Text}}</button>
          <button type="submit" *ngIf="btn2Text" (click)="onBtn2Click()" class="btn wb-btn-default center-block mg-top-24">{{btn2Text}}</button>
          <button type="submit" *ngIf="cancelText" class="btn wb-btn-outline  text-center mg-top-24 mg-btm-9" (click)="onClose()">{{cancelText}}</button>
      </div>
    </div>
  </div>
</div>
